import { FullScreen } from "react-full-screen";
import styled from "styled-components";

export const StyledAppIFrame = styled.iframe`
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;


export const StyledAppIFrameFullScreen = styled(FullScreen)`
  width: 100%;
  height: calc(
    100% -
      ${({ theme, includes_tabs }) =>
        theme.breadcrumbs.height +
        (includes_tabs === "true" ? theme.tabs.height : 0)}px
  );
`;
